export function FontSizeSmallerIcon({ className }: { className: string }) {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" className={className}>
      <path
        d="M14.7803 16.7803C14.921 16.6397 15 16.4489 15 16.25C15 16.0511 14.921 15.8603 14.7803 15.7197C14.6397 15.579 14.4489 15.5 14.25 15.5H9.75C9.55109 15.5 9.36032 15.579 9.21967 15.7197C9.07902 15.8603 9 16.0511 9 16.25C9 16.4489 9.07902 16.6397 9.21967 16.7803C9.36032 16.921 9.55109 17 9.75 17H14.25C14.4489 17 14.6397 16.921 14.7803 16.7803Z"
        fill="currentColor"
      />
      <path
        d="M11.4697 16.7803C11.6103 16.921 11.8011 17 12 17C12.1989 17 12.3897 16.921 12.5303 16.7803C12.671 16.6397 12.75 16.4489 12.75 16.25L12.75 6.75C12.75 6.55109 12.671 6.36032 12.5303 6.21967C12.3897 6.07902 12.1989 6 12 6C11.8011 6 11.6103 6.07902 11.4697 6.21967C11.329 6.36032 11.25 6.55109 11.25 6.75L11.25 16.25C11.25 16.4489 11.329 16.6397 11.4697 16.7803Z"
        fill="currentColor"
      />
      <path
        d="M17.7803 7.28033C17.921 7.13968 18 6.94891 18 6.75C18 6.55109 17.921 6.36032 17.7803 6.21967C17.6397 6.07902 17.4489 6 17.25 6H6.75C6.55109 6 6.36032 6.07902 6.21967 6.21967C6.07902 6.36032 6 6.55109 6 6.75C6 6.94891 6.07902 7.13968 6.21967 7.28033C6.36032 7.42098 6.55109 7.5 6.75 7.5H17.25C17.4489 7.5 17.6397 7.42098 17.7803 7.28033Z"
        fill="currentColor"
      />
      <path
        d="M6.21967 8.78033C6.36032 8.92098 6.55109 9 6.75 9C6.94891 9 7.13968 8.92098 7.28033 8.78033C7.42098 8.63968 7.5 8.44891 7.5 8.25L7.5 6.75C7.5 6.55109 7.42098 6.36032 7.28033 6.21967C7.13968 6.07902 6.94891 6 6.75 6C6.55109 6 6.36032 6.07902 6.21967 6.21967C6.07902 6.36032 6 6.55109 6 6.75L6 8.25C6 8.44891 6.07902 8.63968 6.21967 8.78033Z"
        fill="currentColor"
      />
      <path
        d="M16.7197 8.78033C16.8603 8.92098 17.0511 9 17.25 9C17.4489 9 17.6397 8.92098 17.7803 8.78033C17.921 8.63968 18 8.44891 18 8.25L18 6.75C18 6.55109 17.921 6.36032 17.7803 6.21967C17.6397 6.07902 17.4489 6 17.25 6C17.0511 6 16.8603 6.07902 16.7197 6.21967C16.579 6.36032 16.5 6.55109 16.5 6.75L16.5 8.25C16.5 8.44891 16.579 8.63968 16.7197 8.78033Z"
        fill="currentColor"
      />
    </svg>
  )
}
